// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"XZ-z","dimensionLabel":"YZ-z","styleChooserControlWrapper":"ZZ-z","styleChooserControl":"_Z-z","disabled":"a0-z","giftCard":"b0-z","styleChooserText":"c0-z"};